import React from 'react';
import { Alert } from 'reactstrap';

export default function PrefillError({ error }) {
  if (!error) return null;
  return (
    <Alert color="danger" data-testid="prefillError">
      { error }
    </Alert>
  );
}
